import { HasPermission } from "Core/security";
const SUB_USER_PERMISSION_ACCOUNT = [24]
const SUB_USER_PERMISSION_ACCOUNT_USERS = [31]

export const useSupervisorPermission = (user, currentUser) => {
    if(user?.isSubUser){
        if(currentUser?.customRoleId && !currentUser?.customRole?.isSupervisor) return false
        if(currentUser?.roleId && !currentUser?.role?.isSupervisor) return false
        return HasPermission(user, "accsvr") && HasPermission(user, '', SUB_USER_PERMISSION_ACCOUNT) && HasPermission(user, '', SUB_USER_PERMISSION_ACCOUNT_USERS)
    }
    return HasPermission(user, ["accsvr"]);
};
